import styles from './DslMarineLifeCalendar/Calendar.module.scss'
import { FormattedMessage } from 'react-intl'

const NoResults = () => (
  <div className={styles.noResults}>
    <FormattedMessage
      id='no_information_available_at_this_time'
      defaultMessage='No information available at this time'
    />
  </div>
)

export default NoResults
